module.exports = __webpack_public_path__ + "img/B1.7933b7fe.png";